import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Text,
} from '@razorpay/blade/components';

export interface SendReminderModalProps {
  isOpen: boolean;
  onClose: () => void;
  description: string;
  onSendReminder: () => void;
  isSendingReminder: boolean;
}

export const SendReminderModal = ({
  isOpen,
  onClose,
  description,
  onSendReminder,
  isSendingReminder,
}: SendReminderModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={() => {
        if (!isSendingReminder) {
          onClose();
        }
      }}
      size="small">
      <ModalHeader title="Send Reminder Email" />
      <ModalBody>
        <Box marginY="spacing.3">
          <Text color="surface.text.gray.subtle">{description}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button isDisabled={isSendingReminder} variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button isLoading={isSendingReminder} onClick={onSendReminder}>
            Send Reminder
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
